import PropTypes from 'prop-types';

export const creatorType = PropTypes.shape({
  email: PropTypes.string,
  id: PropTypes.string,
  ttChannels: PropTypes.arrayOf(PropTypes.string),
  updatedAt: PropTypes.string,
});
